import React, { useEffect, useState } from 'react'
import InputAmount from './InputAmount'
import { InputSelect, Option } from './InputSelect'

const SelectionBorderSettings = ({ canvas, activeSelection }) => {
    const [border, setBorder] = useState({
        width: 0,
        style: { strokeDashArray: [], strokeLineCap: 'square' },
        corner: '',
        color: 'rgba(0,0,0,1)'
    })

    useEffect(() => {
        const loadedBorder = {
            width: canvas?.getActiveObject()?.strokeWidth,
            style: {
                strokeDashArray: canvas?.getActiveObject()?.strokeDashArray,
                strokeLineCap: canvas?.getActiveObject()?.strokeLineCap
            },
            corner: canvas?.getActiveObject()?.strokeLineJoin,
            color: canvas?.getActiveObject()?.stroke
        }

        setBorder(loadedBorder)
    }, [activeSelection])

    const handleBorderWidthChange = (action, amount) => {
        let width = 0

        if (action === 'decrease') {
            width = border.width
            width = width === 0 ? 0 : width - 1
        }

        if (action === 'increase') {
            width = border.width ? border.width + 1 : 1
        }

        if (action === 'change') {
            width = parseInt(amount)
            if (!Number.isInteger(width)) return
        }
        if (canvas?.getActiveObject()?.type === 'CustomTextbox') {
            canvas
                ?.getActiveObject()
                .set({ borderWidth: width, strokeUniform: true })
            canvas.requestRenderAll()
        }

        setBorder({ ...border, width: width })

        const applyStyle = (obj) => {
            obj.set({
                strokeUniform: true,
                strokeWidth: width
            })
            // If object is a group, apply styles to its objects
            if (obj.type === 'group') {
                obj.forEachObject((childObj) => {
                    applyStyle(childObj) // Recursively apply style
                })
            }
        }

        canvas?.getActiveObjects().forEach((obj) => {
            applyStyle(obj)
        })
        canvas.requestRenderAll()
        canvas.calcOffset()
        canvas.fire('object:modified')
    }

    const handleBorderStyleChange = (style) => {
        setBorder({ ...border, style: style })
        if (canvas?.getActiveObject()?.type === 'CustomTextbox') {
            canvas?.getActiveObject().set({
                strokeDashArray: style.strokeDashArray,
                strokeLineCap: style.strokeLineCap
            })
            canvas.requestRenderAll()
        } else {
            const applyStyle = (obj) => {
                obj.set({
                    strokeUniform: true,
                    strokeDashArray: style.strokeDashArray,
                    strokeLineCap: style.strokeLineCap
                })
                // If object is a group, apply styles to its objects
                if (obj.type === 'group') {
                    obj.forEachObject((childObj) => {
                        applyStyle(childObj) // Recursively apply style
                    })
                }
            }

            canvas?.getActiveObjects().forEach((obj) => {
                applyStyle(obj) // Apply style to each object or group
            })
        }

        // canvas?.getActiveObjects().forEach((obj) => {
        //     console.log('Style-obj:', obj)
        //     obj.set({
        //         strokeUniform: true,
        //         strokeDashArray: style.strokeDashArray,
        //         strokeLineCap: style.strokeLineCap
        //     })
        // })
        canvas.requestRenderAll()
        canvas.calcOffset()
        canvas.fire('object:modified')
    }

    return (
        <>
            <div className='borderwith-style'>
                <div className='setting'>
                    <div className='function'>
                        <InputAmount
                            unit=''
                            value={border.width}
                            handleDecrease={() =>
                                handleBorderWidthChange('decrease')
                            }
                            handleChange={(e) =>
                                handleBorderWidthChange(
                                    'change',
                                    e.target.value
                                )
                            }
                            handleIncrease={() =>
                                handleBorderWidthChange('increase')
                            }
                        />
                    </div>
                </div>
                <div className='setting'>
                    <div className='function'>
                        <InputSelect
                            activeOption={{
                                strokeDashArray:
                                    border.style.strokeDashArray ?? [],
                                strokeLineCap: border.style.strokeLineCap
                            }}
                            handleChange={(style) =>
                                handleBorderStyleChange(style)
                            }
                        >
                            <Option
                                value={{
                                    strokeDashArray: [],
                                    strokeLineCap: 'butt'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='0'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeLinecap='square'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [1, 10],
                                    strokeLineCap: 'butt'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='0'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='1, 10'
                                        strokeLinecap='square'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [1, 10],
                                    strokeLineCap: 'round'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='0'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='1, 10'
                                        strokeLinecap='round'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [15, 15],
                                    strokeLineCap: 'square'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='0'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='15'
                                        strokeLinecap='square'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [15, 15],
                                    strokeLineCap: 'round'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='0'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='15'
                                        strokeLinecap='round'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [25, 25],
                                    strokeLineCap: 'square'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='0'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='25'
                                        strokeLinecap='square'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [25, 25],
                                    strokeLineCap: 'round'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='0'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='25'
                                        strokeLinecap='round'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [1, 8, 16, 8, 1, 20],
                                    strokeLineCap: 'square'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='2'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='1 8 16 8 1 20'
                                        strokeLinecap='square'
                                    />
                                </svg>
                            </Option>
                            <Option
                                value={{
                                    strokeDashArray: [1, 8, 16, 8, 1, 20],
                                    strokeLineCap: 'round'
                                }}
                            >
                                <svg>
                                    <line
                                        x1='2'
                                        y1='2'
                                        x2='100'
                                        y2='2'
                                        stroke='#000'
                                        strokeWidth='4'
                                        strokeDasharray='1 8 16 8 1 20'
                                        strokeLinecap='round'
                                    />
                                </svg>
                            </Option>
                        </InputSelect>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SelectionBorderSettings
